import { fetch, PromiseWithErrorHandler } from '@maxtropy/components';
import { Gender, LeftNavPreference, OuStaffType, UserStatus } from './const';
import { Customer } from '@maxtropy/components/es/api/entity';
export interface OrganizationTreeData {
  code?: string;
  hasPermission?: boolean;
  levelName?: string;
  mcid: string;
  name?: string;
  canAddSub?: boolean;
  fullName?: string;
}

export interface OrganizationTreeProps {
  children: OrganizationTreeProps[];
  data?: OrganizationTreeData;
  parent?: number;
}

export function getOrganizationTree(): Promise<OrganizationTreeProps> {
  return fetch(
    `/api/v2/customer/organization-with-code`,
    {
      method: 'POST',
    },
    true
  );
}

export function getAllOrganizationTree(): Promise<OrganizationTreeProps> {
  return fetch(
    `/api/v2/customer/all-organization-with-code`,
    {
      method: 'POST',
    },
    true
  );
}

export function getOrganizationWithCodeWithCurrent(): Promise<OrganizationTreeProps> {
  return fetch(
    `/api/v2/customer/organization-with-code-with-current`,
    {
      method: 'POST',
    },
    true
  );
}

export interface SummaryProps {
  projectSum: number;
  staffSum: number;
  allStaffsSum: number;
  allProjectsSum: number;
}

export function getSummary(mcid: string): Promise<SummaryProps> {
  return fetch(
    `/api/v2/customer/summary`,
    {
      method: 'POST',
      body: JSON.stringify({ mcid }),
    },
    true
  );
}

export interface CreateCustomerProps {
  name: string;
  fullName: string;
  logoUrl?: string;
  platformTitleConfig?: boolean;
  iconUrl?: string;
  platformTitleType?: number;
  platformName?: string;
  homePageLogoConfig?: boolean;
  homepageLogoUrl?: string;
  platformSloganNameConfig?: boolean;
  platformSloganName?: string;
  staffIds: number[];
}

export function createCustomer(parentMcid: string, body: CreateCustomerProps) {
  return fetch(
    `/api/v2/customer/create`,
    {
      method: 'POST',
      body: JSON.stringify({ parentMcid, ...body }),
    },
    true
  );
}

export interface CustomerProps {
  mcid: string;
  name: string;
  fullName: string;
  uscc?: string;
  address?: string;
  phone?: string;
  adCode?: string;
  logoUrl?: string;
  disabled?: boolean;
  provinceCityDistrict?: string;
  code?: string;
  createTime?: string;
  updateTime?: string;
  platformTitleConfig: boolean;
  iconUrl: string;
  platformTitleType: number;
  platformName?: string;
  homePageLogoConfig: boolean;
  homePageLogoUrl?: string;
  platformSloganNameConfig?: boolean;
  platformSloganName?: string;
}

export function getCustomer(mcid: string): Promise<CustomerProps> {
  return fetch(
    `/api/v2/customer`,
    {
      method: 'POST',
      body: JSON.stringify({ mcid }),
    },
    true
  );
}

export function updateCustomer(mcid: string, body: CreateCustomerProps) {
  return fetch(
    `/api/v2/customer/update`,
    {
      method: 'POST',
      body: JSON.stringify({ mcid, ...body }),
    },
    true
  );
}

export interface MoveCustomerProps {
  source?: string;
  target?: string;
  name?: string;
  fullName?: string;
  logoUrl?: string;
  muid?: string;
  parentMcid?: string;
  operationPassword?: string;
  targeCode?: string;
  targetName?: string;
  targetLevelName?: string;
}

export function moveCustomer(body: MoveCustomerProps) {
  return fetch<{ moveResult: boolean }>(
    `/api/v2/customer/move`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
    true
  );
}

export interface CustomerListProps {
  muid: string;
  username: string;
  name: string;
  cellphone?: string;
  passwordUpdateTime?: string;
  createTime?: string;
  updateTime?: string;
  status?: UserStatus;
  gender?: Gender;
  birthday?: string;
  email?: string;
  wechat?: string;
  qq?: string;
  headPic?: string;
  humanCode?: string;
}

export function getListCustomer(value: string): PromiseWithErrorHandler<{ list: CustomerListProps[] }> {
  return fetch(
    `/api/v2/staff/customerUser/list`,
    {
      method: 'POST',
      body: JSON.stringify({ value }),
    },
    true
  );
}

export function getDescendants(): Promise<{ list: Customer[] }> {
  return fetch(
    `/api/v2/customer/descendants`,
    {
      method: 'POST',
    },
    true
  );
}

export interface DeleteCustomerProps {
  muid: string;
  operationPassword: string;
}

export function deleteCustomer(mcid: string, body: DeleteCustomerProps) {
  return fetch(
    `/api/v2/customer/delete`,
    {
      method: 'POST',
      body: JSON.stringify({ mcid, ...body }),
    },
    true
  );
}

export function getNextLevelName(mcid: string): Promise<{ levelName: string }> {
  return fetch(
    `/api/v2/customer/next-level-name`,
    {
      method: 'POST',
      body: JSON.stringify({ mcid }),
    },
    true
  );
}

export interface CheckNameUniqueProps {
  name?: string;
  fullName?: string;
}

export function checkNameUnique(query?: CheckNameUniqueProps) {
  return fetch<{ checkResult: boolean }>(
    `/api/v2/customer/checkNameUnique`,
    {
      method: 'POST',
      body: JSON.stringify(query),
    },
    true
  );
}

export interface CheckNameUniqueProps {
  name?: string;
  fullName?: string;
}

export function cpSyncProgress() {
  return fetch<{ name: string; progress: number; time: string }>(
    // `http://10.50.16.213:40001/mock/491/api/v2/customer/cpSyncProgress`,
    `/api/v2/customer/cpSyncProgress`,
    {
      method: 'POST',
    },
    true
  );
}
export function cpSync() {
  return fetch(
    `/api/v2/customer/cpSync`,
    {
      method: 'POST',
    },
    true
  );
}

export interface CpStaffPageReq {
  page: number;
  size: number;
  username?: string;
  cellphone?: string;
  mcids?: string[];
}

export interface StaffListResponse {
  muid: string;
  name: string;
  username: string;
  cellphone: string;
  orgName: string;
  orgId: string;
}

export function getCpStaffPageList(params: CpStaffPageReq) {
  return fetch<{ total: number; page: number; size: number; list: StaffListResponse[] }>(
    `/api/v2/customer/cpStaffPage`,
    // `http://10.50.16.213:40001/mock/491/api/v2/customer/cpStaffPage`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export interface CpUserInfo {
  password?: string;
  muid: string;
  username: string;
  name: string;
  cellphone: string;
  passwordUpdateTime: string;
  status: number;
  gender?: number;
  birthday?: number;
  email?: string;
  wechat?: string;
  qq?: string;
  headPic?: string;
  humanCode?: string;
}

export function getCpUserInfo(staffId: string) {
  return fetch<CpUserInfo>(
    `/api/v2/customer/cpUserInfo`,
    // 'http://10.50.16.213:40001/mock/491/api/v2/customer/cpUserInfo',
    {
      method: 'POST',
      body: JSON.stringify({ staffId }),
    },
    true
  );
}

export interface CpOrgInfo {
  orgId: string; // 外部组织ID
  orgName: string; //外部组织名称
}
export function getCpOrgInfoList() {
  return fetch<{ list: CpOrgInfo[] }>(
    `/api/v2/customer/cpOrgInfo`,
    // 'http://10.50.16.213:40001/mock/491/api/v2/customer/cpOrgInfo',
    {
      method: 'POST',
    },
    true
  );
}
export interface CustomerAuthorityBatch {
  staffList: {
    staffId: number; // 员工ID
    navigationPreference: LeftNavPreference; //左侧导航栏状态
  }[];
  roleId: string; //角色ID
  ouList: {
    ouMemberType: OuStaffType;
    ouIds: number[];
  }[]; //运营单元集合
}
export function updateCustomerAuthorityBatch(params: CustomerAuthorityBatch) {
  return fetch(
    `/api/v2/customer/updateCustomerAuthorityBatch`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
export interface CustomerAuthority {
  staffId: number; // 员工ID
  navigationPreference: LeftNavPreference; //左侧导航栏状态
  mcid: string; //组织ID
  roleId: string; //角色ID
  ouList: {
    ouMemberType: OuStaffType;
    ouIds: number[];
  }[]; //运营单元集合
}
export function updateCustomerAuthority(params: CustomerAuthority) {
  return fetch(
    `/api/v2/customer/updateCustomerAuthority`,
    // 'http://10.50.16.213:40001/mock/491/api/v2/customer/updateCustomerAuthority',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
